import checkUnit from '../utils/checkUnit.js';

/**
 * Calculates the map scale from a given map resolution.
 *
 * Formula reference:
 * scale = resolution * (meters per inch) * (inches per meter) * (mm per pixel)
 * Here, 39.37 converts meters to inches, and 25.4 / 0.28 converts
 * pixel size (0.28mm/pixel standard) to inches.
 *
 * @param {number} resolution - Map resolution (map units per pixel).
 * @returns {number} The map scale (1:x).
 */
export default function getScaleFromResolution(resolution) {
  if (typeof resolution !== 'number' || isNaN(resolution)) {
    console.warn('getScaleFromResolution: invalid resolution value');
    return 0;
  }

  const metersPerUnit = checkUnit('m'); // conversion factor for the projection units
  const inchesPerMeter = 39.37;
  const mmPerInch = 25.4;
  const pixelSizeMm = 0.28;

  const scale = resolution * (inchesPerMeter * metersPerUnit * (mmPerInch / pixelSizeMm));
  return parseFloat(scale);
}
